import axios from 'axios'

axios.defaults.baseURL="/api";
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

export const api = axios.create({
    baseURL: "/api",
    withCredentials: true,
    withXSRFToken: true,
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "X-Frame-Options": "deny",
        "X-Content-Type-Origins": "nosniff",
        "Referrer-Policy": "same-origin"
    },
});

axios.interceptors.request.use((config) => {
    return config
}, (error) => {
    return Promise.reject(error)
})

axios.interceptors.response.use((response) => {
    return response
}, function(error) {
    return Promise.reject(error)
})
